/* Headern följer med uppåt och glider undan nedåt. Beskrivning i snippets/NV-HEADER-SCROLL.liquid. */
(function () {
  var wrap = document.querySelector('[data-nv-header-wrap]');
  if (!wrap) return;
  var pin = wrap.querySelector('[data-site-header]') || wrap;
  pin.classList.add('nv-header-pin');

  var spacer = document.createElement('div');
  spacer.className = 'nv-header-spacer';
  spacer.setAttribute('aria-hidden', 'true');
  pin.parentNode.insertBefore(spacer, pin);

  var STATIC = 'static', SHOWN = 'shown', HIDDEN = 'hidden';
  var state = STATIC;
  var lastY = window.pageYOffset || 0;
  var pinH = pin.offsetHeight;   // headerradens höjd
  var natTop = 0;                // var headerraden ligger i sidan (under utility bar m.m.)
  var ticking = false;
  // Sträcka i samma riktning innan headern byter läge. Små ryck fram och
  // tillbaka (styrplatta, finger som vilar) ska inte fälla ut och in den.
  var SHOW_PX = 10;
  var HIDE_PX = 16;
  var travel = 0; // scrollat i nuvarande riktning: plus nedåt, minus uppåt

  // Platshållarens höjd: headern utan den säkra kanten ovanför (border-top)
  function spacerHeight() { return pin.offsetHeight - pin.clientTop; }

  function measureNatural() {
    var el = state === STATIC ? pin : spacer;
    natTop = Math.round(el.getBoundingClientRect().top + (window.pageYOffset || 0));
    if (state === STATIC) pinH = pin.offsetHeight;
  }
  measureNatural();

  function locked() {
    var b = document.body;
    if (!b) return false;
    // Rör inte headern medan menyn, varukorgen eller sökningen är öppen
    if (b.classList.contains('nv-meny-open') || b.classList.contains('nvd-drawer-open')) return true;
    var a = document.activeElement;
    if (a && a !== b && pin.contains(a) && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
    if (wrap.querySelector('.live-search--active, .live-search--takeover')) return true;
    // Tangentbordsfokus i headern: håll den framme tills fokus lämnar den
    if (keyFocusInside()) return true;
    return false;
  }

  // Har headern tangentbordsfokus (Tab) just nu? Fokus kvar på en knapp efter
  // ett musklick räknas inte, annars skulle headern aldrig glida undan.
  var viaKeyboard = false;
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' || e.key === 'Shift') viaKeyboard = true;
  }, true);
  document.addEventListener('mousedown', function () { viaKeyboard = false; }, true);
  document.addEventListener('touchstart', function () { viaKeyboard = false; }, { capture: true, passive: true });
  function keyFocusInside() {
    var a = document.activeElement;
    if (!a || a === document.body || !pin.contains(a)) return false;
    try { return a.matches(':focus-visible') || viaKeyboard; } catch (err) { return viaKeyboard; }
  }

  function offset() {
    if (state === SHOWN) return pinH;
    if (state === HIDDEN) return 0;
    return Math.max(0, natTop + pinH - (window.pageYOffset || 0));
  }

  function emit() {
    // Sticky element (produktgalleriet, innehållsförteckningen i artiklar,
    // läsmätaren i BLOG-PROGRESS-BAR) flyttar ner sig under headern.
    // Klasserna på <html> speglar läget för CSS som inte vill läsa variabeln.
    var root = document.documentElement;
    root.style.setProperty('--nv-header-offset', (state === SHOWN ? pinH : 0) + 'px');
    root.classList.toggle('nv-header-shown', state === SHOWN);
    root.classList.toggle('nv-header-hidden', state === HIDDEN);
    document.dispatchEvent(new CustomEvent('nv:header', { detail: { state: state, offset: offset() } }));
  }

  function setState(next) {
    if (next === state) return;
    var prev = state;
    state = next;
    if (next === STATIC) {
      // Tillbaka till flödet utan animation: platshållaren ligger precis där den fästa headern står
      pin.classList.add('no-anim');
      pin.classList.remove('is-pinned', 'is-hidden');
      spacer.classList.remove('is-active');
      void pin.offsetHeight;
      pin.classList.remove('no-anim');
    } else if (prev === STATIC) {
      pinH = pin.offsetHeight;
      spacer.style.height = pinH + 'px';
      spacer.classList.add('is-active');
      // Fäst den utanför skärmen först, låt den sedan glida in (eller stanna dold)
      pin.classList.add('no-anim', 'is-pinned', 'is-hidden');
      pinH = pin.offsetHeight; // med den säkra kanten ovanför
      pin.classList.remove('no-anim');
    }
    if (next === SHOWN) pin.classList.remove('is-hidden');
    if (next === HIDDEN) pin.classList.add('is-hidden');
    emit();
  }

  function update() {
    ticking = false;
    var y = window.pageYOffset || 0;

    // Mjuk överlämning: när sidan har scrollat upp så långt att headerns egen
    // plats är nådd tar flödet över, på exakt samma ställe.
    if (state !== STATIC && y <= natTop) { lastY = y; travel = 0; setState(STATIC); return; }
    if (y <= 0) { lastY = y; travel = 0; setState(STATIC); return; }

    // Gummibandet i botten på iOS studsar tillbaka uppåt: räkna inte det som scroll uppåt
    var maxY = document.documentElement.scrollHeight - window.innerHeight;
    if (maxY > 0 && y > maxY) y = maxY;

    var dy = y - lastY;
    if (!dy) return;
    lastY = y;
    if ((dy > 0) !== (travel > 0)) travel = 0;
    travel += dy;
    if (locked()) { travel = 0; return; }

    var past = y > natTop + pinH; // headerns plats har scrollat ur bild
    var next = state;
    if (state === STATIC) {
      if (travel <= -SHOW_PX && past) next = SHOWN;
    } else if (state === SHOWN) {
      if (travel >= HIDE_PX && past) next = HIDDEN;
    } else if (state === HIDDEN) {
      if (travel <= -SHOW_PX) next = SHOWN;
    }
    if (next !== state) { travel = 0; setState(next); }
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  function remeasure() {
    if (state !== STATIC) {
      var h = pin.offsetHeight;
      var changed = h !== pinH;
      pinH = h;
      spacer.style.height = spacerHeight() + 'px';
      if (changed) emit();
    }
    measureNatural();
  }
  window.addEventListener('resize', remeasure, { passive: true });
  window.addEventListener('load', remeasure);
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(remeasure);
    ro.observe(pin);
    ro.observe(wrap);
  }

  // Fokus som hamnar i en dold header (Tab, eller fokus som lämnas tillbaka
  // när en meny stängs) ska aldrig vara osynligt: visa headern direkt.
  pin.addEventListener('focusin', function () {
    if (state === HIDDEN) {
      setState(SHOWN);
      lastY = window.pageYOffset || 0;
      travel = 0;
    }
  });

  window.NVHeader = {
    offset: offset,
    state: function () { return state; },
    show: function () { if (state === HIDDEN) setState(SHOWN); },
    hide: function () { if (state === SHOWN && (window.pageYOffset || 0) > natTop + pinH) setState(HIDDEN); }
  };
})();
